import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";

import LanguageToggle from "./LanguageToggle";
import LoginRegisterButton from "./LoginRegisterButton";

class Topbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      navLinks: []
    };

    this.toggleLine = this.toggleLine.bind(this);
    this.openBlock.bind(this);
  }

  toggleLine() {
    this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
  }

  componentDidMount() {
    var ul = document.getElementById("top-menu");
    if (!ul) return;
    var items = ul.getElementsByTagName("a");
    var matchingMenuItem = null;
    for (var i = 0; i < items.length; ++i) {
      if (this.props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem);
    }
  }

  activateParentDropdown = (item) => {
    const parent = item.parentElement;
    if (parent) {
      parent.classList.add("active");
      const parent1 = parent.parentElement;
      if (parent1) parent1.classList.add("active");
    }
  };

  openBlock = (level2_id) => {
    var tmpLinks = this.state.navLinks;
    tmpLinks.map((tmpLink) =>
      tmpLink.id === level2_id
        ? (tmpLink.isOpenSubMenu = !tmpLink.isOpenSubMenu)
        : false
    );
    this.setState({ navLinks: tmpLinks });
  };

  render() {
    const hasLogo = !!this.props.logo;

    return (
      <header className="f-topbar">
        <div className="f-topbar-inner">
          <Link to="/" className="f-topbar-brand" aria-label="Home">
            {hasLogo && (
              <img
                src={this.props.logo}
                alt=""
                width="180"
                height="48"
                fetchpriority="high"
                decoding="async"
                style={{ height: 48, width: 'auto', maxWidth: 180, objectFit: 'contain', display: 'block' }}
              />
            )}
          </Link>

          <ul id="top-menu" className="f-topbar-nav" style={{ display: 'flex', gap: 28, listStyle: 'none', margin: 0, padding: 0 }}>
            {this.state.navLinks.map((navLink, key) => (
              <li key={key}>
                <Link to={navLink.link}>{navLink.title}</Link>
              </li>
            ))}
          </ul>

          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 12 }}>
            <LanguageToggle />
            <LoginRegisterButton />
          </div>
        </div>
      </header>
    );
  }
}

export default withRouter(Topbar);
